(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-bundle-script"] && !Shopify.designMode) return;
  try {
    class QuantityBundle extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.form = this.querySelector('.quantity-bundle__form');
      this.tiers = [...this.querySelectorAll('.quantity-bundle__tier')];
      this.ctaPrice = this.querySelector('[ref="ctaPrice"]');
      this.cta = this.querySelector('.quantity-bundle__cta');
      this.errorEl = this.querySelector('.quantity-bundle__error');
      this.touched = false;
      this.count = 1;
      this.addon = this.querySelector('[ref="addon"]');
      this.addonCheck = this.querySelector('[ref="addonCheck"]');
      this.addonQty = this.querySelector('[ref="addonQty"]');
      this.addonQtyWrap = this.querySelector('[ref="addonQtyWrap"]');
      this.addonPrice = this.querySelector('[ref="addonPrice"]');
      this.addonQtyTouched = false;

      this.addEventListener('change', (event) => {
        const target = event.target;
        if (target === this.addonCheck) {
          this.syncAddon();
          return;
        }
        if (target === this.addonQty) {
          this.addonQtyTouched = true;
          this.syncAddon();
          return;
        }
        if (!(target instanceof HTMLInputElement)) return;
        this.touched = true;
        if (target.classList.contains('quantity-bundle__radio')) {
          this.select(Number(target.value));
        }
      }, { signal });
      this.form?.addEventListener('submit', (event) => this.submit(event), { signal });

      this.setupSizeGuide(signal);
      this.setupStickyBar(signal);

      const checked = this.querySelector('.quantity-bundle__radio:checked');
      this.select(checked instanceof HTMLInputElement ? Number(checked.value) : 1);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      // The sticky bar lives on <body> while connected; take it back out with the block.
      this.sticky?.remove();
    }

    /** @param {AbortSignal} signal */
    setupSizeGuide(signal) {
      const dialog = this.querySelector('[ref="sizeGuide"]');
      const opener = this.querySelector('[ref="sizeGuideOpen"]');
      if (!(dialog instanceof HTMLDialogElement) || !(opener instanceof HTMLButtonElement)) return;
      opener.addEventListener('click', () => dialog.showModal(), { signal });
      dialog.querySelector('[ref="sizeGuideClose"]')?.addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => opener.focus(), { signal });
    }

    /** @param {AbortSignal} signal */
    setupStickyBar(signal) {
      const bar = this.querySelector('[ref="stickyBar"]');
      if (!(bar instanceof HTMLElement) || !this.cta) return;
      this.sticky = bar;
      this.stickyPrice = bar.querySelector('[ref="stickyPrice"]');
      // Fixed positioning must not depend on the section's own layout context.
      document.body.append(bar);
      bar.querySelector('[ref="stickyCta"]')?.addEventListener('click', () => this.stickyClick(), { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry) this.toggleSticky(!entry.isIntersecting);
      });
      this.observer.observe(this.cta);
    }

    /** @param {boolean} show */
    toggleSticky(show) {
      if (!this.sticky) return;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.toggleAttribute('inert', !show);
      this.sticky.setAttribute('aria-hidden', String(!show));
    }

    stickyClick() {
      // Until a size has been picked, take the shopper to the picker instead of buying the default size.
      if (!this.touched) {
        this.touched = true;
        this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const choice = this.querySelector('.quantity-bundle__tier.is-selected .quantity-bundle__option input:checked');
        if (choice instanceof HTMLInputElement) choice.focus({ preventScroll: true });
        return;
      }
      this.form?.requestSubmit();
    }

    /** @param {number} count */
    select(count) {
      for (const tier of this.tiers) {
        const isSelected = Number(tier.dataset.tier) === count;
        tier.classList.toggle('is-selected', isSelected);
        const items = tier.querySelector('.quantity-bundle__items');
        if (items instanceof HTMLElement) {
          items.hidden = !isSelected;
          // Only the selected tier's inputs are sent with the form.
          for (const input of items.querySelectorAll('input')) {
            if (input.closest('.is-unavailable')) continue;
            input.disabled = !isSelected;
          }
        }
      }
      this.count = count;
      this.syncAddon();
    }

    addonOn() {
      return this.addonCheck instanceof HTMLInputElement && this.addonCheck.checked;
    }

    addonQuantity() {
      if (!this.addonOn()) return 0;
      return Math.max(1, Number(this.addonQty instanceof HTMLSelectElement ? this.addonQty.value : 1) || 1);
    }

    /** Keeps the power bank box, its quantity and the button total in step with the chosen pack. */
    syncAddon() {
      if (this.addon instanceof HTMLElement && this.addonQty instanceof HTMLSelectElement) {
        const n = this.count;
        const current = Number(this.addonQty.value) || n;
        // One power bank per coat by default; a shopper's own choice is kept within the pack size.
        const wanted = this.addonQtyTouched ? Math.min(Math.max(current, 1), n) : n;
        this.addonQty.replaceChildren(
          ...Array.from({ length: n }, (_, i) => new Option(String(i + 1), String(i + 1), false, i + 1 === wanted))
        );
        if (this.addonQtyWrap instanceof HTMLElement) this.addonQtyWrap.hidden = !(this.addonOn() && n > 1);
        this.addon.classList.toggle('is-on', this.addonOn());
        if (this.addonPrice) {
          const cents = Number(this.addon.dataset.cents) || 0;
          this.addonPrice.textContent = `+ ${this.formatMoney(cents * Math.max(1, this.addonQuantity()))}`;
        }
      }
      this.updateTotal();
    }

    updateTotal() {
      const tier = this.tiers.find((t) => Number(t.dataset.tier) === this.count);
      if (!tier) return;
      let text = tier.dataset.price ?? '';
      const quantity = this.addonQuantity();
      if (quantity > 0 && this.addon instanceof HTMLElement) {
        const total = (Number(tier.dataset.cents) || 0) + (Number(this.addon.dataset.cents) || 0) * quantity;
        text = this.formatMoney(total);
      }
      if (this.ctaPrice) this.ctaPrice.textContent = text;
      if (this.stickyPrice) this.stickyPrice.textContent = text;
    }

    /**
     * Formats minor units like the store's `money` filter, using a sample amount rendered by Liquid.
     * @param {number} cents
     */
    formatMoney(cents) {
      const sample = this.dataset.moneySample ?? '';
      let match = sample.match(/^([\s\S]*?)1(\D?)234(\D)56([\s\S]*)$/);
      let decimals = true;
      if (!match) {
        match = sample.match(/^([\s\S]*?)1(\D?)235()([\s\S]*)$/);
        decimals = false;
      }
      if (!match) return (cents / 100).toFixed(2);
      const [, prefix, thousands, decimal, suffix] = match;
      const fixed = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      const [whole = '0', fraction = ''] = fixed.split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands ?? '');
      return `${prefix}${grouped}${decimals ? `${decimal}${fraction}` : ''}${suffix}`;
    }

    /** @param {SubmitEvent} event */
    async submit(event) {
      event.preventDefault();
      if (!(this.form instanceof HTMLFormElement) || !this.cta) return;

      const data = new FormData(this.form);
      /** @type {Map<string, number>} */
      const counts = new Map();
      for (const [key, value] of data.entries()) {
        if (/^items\[\d+\]\[id\]$/.test(key)) {
          const id = String(value);
          counts.set(id, (counts.get(id) ?? 0) + 1);
        }
      }
      if (counts.size === 0) return;

      const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
      const addonQuantity = this.addonQuantity();
      if (addonQuantity > 0 && this.addon instanceof HTMLElement && this.addon.dataset.variantId) {
        items.push({ id: Number(this.addon.dataset.variantId), quantity: addonQuantity });
      }
      this.cta.setAttribute('aria-busy', 'true');
      this.cta.disabled = true;
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || body.message || this.dataset.error);
        }
        window.location.href = this.dataset.checkoutUrl || '/checkout';
      } catch (error) {
        if (this.errorEl) {
          this.errorEl.textContent = error instanceof Error && error.message ? error.message : (this.dataset.error ?? '');
          this.errorEl.hidden = false;
        }
        this.cta.disabled = false;
        this.cta.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('quantity-bundle')) customElements.define('quantity-bundle', QuantityBundle);
  } catch(e) { console.error(e); }
})();

})();
